import styled from "styled-components";

export const MoreMediaArticlesWrapper = styled.div`
	max-width: 844px;
	margin: 50px 0;
	background-color: white;
	padding: 30px;
	border-radius: 6px;
`;

export const MoreMediaArticlesHeader = styled.span`
	font-size: 32px;
	font-weight: 400;
`

export const MoreMediaArticleCardsContainer = styled.div<{ isSingle: boolean }>`
	margin-top: 30px;
	display: ${props => (props.isSingle ? 'block' : 'grid')};
	--columns: 2;
	grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
	align-items: stretch;
	grid-gap: 28px;

	@media (max-width: 794px) {
		--columns: 1;
	}

	p:first-of-type {
        margin-top: 0px !important;
	}

	[class*='SimpleGridstyle__SimpleGridColumn-sc'] {
		margin-top: 0px;
	}
`;